<template>
  <router-view />
</template>

<script>
import store, { name } from '@/modules/periodEnd/store';
import storeMixin, { unRegisterMixin } from 'utils/mixins/storeGenerator';
import visitRegistryStore, {
  name as visitRegistryModuleName,
} from '@/modules/visitRegistry/store';

export default {
  name: 'PeriodEndWrapper',
  mixins: [storeMixin, unRegisterMixin],
  created() {
    if (this.$store.state[name] == undefined) {
      this.$store.registerModule(name, store);
    }
    if (this.$store.state[visitRegistryModuleName] == undefined) {
      this.$store.registerModule(visitRegistryModuleName, visitRegistryStore);
    }
  },
  destroyed() {
    this.$store.dispatch(`${name}/reset`);
  },
};
</script>
